import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Causes from "./components/Causes";
import Programs from "./components/Programs";
import Impact from "./components/Impact";
import Donate from "./components/Donate";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Roadmap from "./components/Roadmap";
import MissionPage from "./pages/MissionPage";
import {
  NewsletterListPage,
  NewsletterPostPage,
} from "./pages/NewsletterPage";
import AdminNewsletterPage from "./pages/AdminNewsletterPage";

function ScrollToHash() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Defer until DOM paints
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location]);
  return null;
}

function HomePage() {
  return (
    <main>
      <Hero />
      <About />
      <Causes />
      <Programs />
      <Impact />
      <Donate />
      <Roadmap />
      <Contact />
    </main>
  );
}

function Layout({ children }) {
  return (
    <div className="App bg-[#FAF5F0]">
      <Header />
      {children}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: "16px",
          },
        }}
      />
      <ScrollToHash />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />
        <Route
          path="/mission"
          element={
            <Layout>
              <MissionPage />
            </Layout>
          }
        />
        <Route
          path="/newsletter"
          element={
            <Layout>
              <NewsletterListPage />
            </Layout>
          }
        />
        <Route
          path="/newsletter/:slug"
          element={
            <Layout>
              <NewsletterPostPage />
            </Layout>
          }
        />
        <Route path="/admin/newsletter" element={<Layout><AdminNewsletterPage /></Layout>} />
        <Route
          path="*"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
